import { render, staticRenderFns } from "./UserCompanyAdminDetails.vue?vue&type=template&id=57ab07bf"
import script from "./UserCompanyAdminDetails.vue?vue&type=script&lang=js"
export * from "./UserCompanyAdminDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports